import React, { useRef, useState } from "react";
import { FaArrowLeftLong, FaArrowRightLong } from "react-icons/fa6";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import "swiper/css";


import Member1 from "../../assets/image_5.png"
import Member2 from "../../assets/image_6.jpg"
import Member3 from "../../assets/image_7.png"
import Member4 from "../../assets/image_8.png"
import Member5 from "../../assets/image_9.png"

const members = [
  {
    role: "Ben, Tuber Delivery Driver",
    image: Member1,
    description:
      "I love the flexibility of being a Tuber driver. I get to work when I want, earn great money, and help keep tradies working without delays.",
  },
  {
    role: "Tommy, Tuber Delivery Driver",
    image: Member2,
    description:
      "Every delivery is a chance to make someone’s day easier. The app makes my job simple and efficient.",
  },
  {
    role: "Sean, Tuber Delivery Driver",
    image: Member3,
    description:
      "I never realised how much time tradies lose picking up supplies—until I started delivering for Tuber. Now I see the impact firsthand.",
  },
  {
    role: "Pete, Founder",
    image: Member4,
    description:
      "We built Tuber because we lived the problem. Now, we’re solving it for thousands of tradies across Australia.",
  },
  {
    role: "Emma, Administration Team Member",
    image: Member5,
    description:
      "Behind every seamless delivery is a dedicated team making sure things run smoothly. I love being part of that.",
  },
];



const MeetMembers = () => {
  const swiperRef = useRef(null);
  const [isEnd, setIsEnd] = useState(false);
  const [isBeginning, setIsBeginning] = useState(true);

  const handleSlideChange = () => {
    if (swiperRef.current) {
      setIsBeginning(swiperRef.current.isBeginning);
      setIsEnd(swiperRef.current.isEnd);
    }
  };

  return (
    <section className="pb-10 lg:pb-28 max-w-[1920px] w-full mx-auto">
      <div className="max-w-[1648px] xl:w-[88.6vw] xl:min-w-[1280px] ml-auto">
        <div className="flex flex-col lg:flex-row">
          {/* Left Section */}
          <div className="w-full lg:w-[35%] pl-4 xl:pl-0 pr-3 mb-10 lg:mb-0">
            <h2 className="text-3xl md:text-4xl md:max-w-[350px] font-bold mb-2 md:mb-6 text-headings capitalize">
              Meet some of our people
            </h2>
            <p className="text-light_black max-w-[500px] text-sm md:text-lg">
              We’re real people, making a real difference.
            </p>
            <div className="flex gap-[10px] justify-end lg:justify-start mt-8">
              {/* Custom Navigation Buttons */}
              <button
                className={`w-12 h-12 lg:border border-black/20 rounded-full transition-all duration-300 lg:hover:bg-primary lg:hover:text-white flex justify-center items-center ${isBeginning ? "opacity-40 cursor-not-allowed" : "opacity-100"
                  }`}
                onClick={() => swiperRef.current?.slidePrev()}
                disabled={isBeginning}
              >
                <FaArrowLeftLong />
              </button>
              <button
                className={`w-12 h-12 lg:border border-black/20 rounded-full transition-all duration-300 lg:hover:bg-primary lg:hover:text-white flex justify-center items-center ${isEnd ? "opacity-40 cursor-not-allowed" : "opacity-100"
                  }`}
                onClick={() => swiperRef.current?.slideNext()}
                disabled={isEnd}
              >
                <FaArrowRightLong />
              </button>
            </div>
          </div>

          {/* Right Section - Swiper Slider */}
          <div className="w-full lg:w-[65%]">
            <Swiper
              spaceBetween={0}
              slidesPerView="auto"
              modules={[Navigation]}
              onSwiper={(swiper) => (swiperRef.current = swiper)}
              onSlideChange={handleSlideChange}
              className="mySwiper mx-4"
            >
              {members.map((member, index) => (
                <SwiperSlide key={index} style={{ width: "320px" }}>
                  <div className="border border-[#f7f7f7] rounded-2xl mb-5 overflow-hidden mx-2 shadow-sm hover:shadow-md transition-shadow duration-300">
                    <div className="h-[220px] w-full relative">
                      <img
                        src={member.image}
                        alt={member.name}
                        loading="lazy"
                        className="w-full h-full object-cover"
                      />
                    </div>
                    <div className="p-4">
                      <h2 className="text-base text-headings font-semibold mb-2">
                        {member.role}
                      </h2>
                      <p className="text-sm text-light_black">{member.description}</p>
                    </div>
                  </div>

                </SwiperSlide>
              ))}

            </Swiper>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MeetMembers;
